import React from 'react';
import {Box, Grid, Typography} from '@mui/material';
import {
  PersonAdd as PersonAddIcon,
  Mail as MailIcon,
  HowToReg as HowToRegIcon,
} from '@mui/icons-material';
import {useAppSelector} from 'src/redux/hooks';
import {selectTenantStats} from 'src/redux/slice/residentSlice';
import {Tenant, TenantStatusEnum} from 'src/apis/autoGenerate/types/tenant';
import {EntioCard} from 'src/components/ui';
import {brand, semantic} from 'src/theme';

export default function ResidentStatusCard() {
  const tenantList = useAppSelector(selectTenantStats);

  const totalCreated = tenantList.filter(
    (tenant: Tenant) => tenant.status === TenantStatusEnum.Created
  ).length;
  const totalInvited = tenantList.filter(
    (tenant: Tenant) => tenant.status === TenantStatusEnum.Pending
  ).length;
  const totalActivated = tenantList.filter(
    (tenant: Tenant) => tenant.status === TenantStatusEnum.Enabled
  ).length;

  const stats = [
    {
      icon: <PersonAddIcon />,
      label: 'Created',
      value: totalCreated,
      color: brand[500],
      bgColor: brand[100],
    },
    {
      icon: <MailIcon />,
      label: 'Invited',
      value: totalInvited,
      color: semantic.success.main,
      bgColor: semantic.success.light,
    },
    {
      icon: <HowToRegIcon />,
      label: 'Activated',
      value: totalActivated,
      color: semantic.info.main,
      bgColor: semantic.info.light,
    },
  ];

  return (
    <EntioCard title="Residents Status">
      <Grid
        container
        spacing={{xs: 1, sm: 2}}
        sx={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
          {stats.map((stat, index) => (
            <Grid
              item
              xs={4}
              key={index}
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: 'fit-content',
                }}
              >
                <Box
                  sx={{
                    width: {xs: 40, sm: 48},
                    height: {xs: 40, sm: 48},
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: stat.bgColor,
                    color: stat.color,
                    mb: 1,
                    '& svg': {
                      fontSize: {xs: 20, sm: 24},
                    },
                  }}
                >
                  {stat.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    mb: 0.5,
                    fontSize: {xs: '1rem', sm: '1.25rem'},
                    lineHeight: 1.2,
                  }}
                >
                  {stat.value}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontSize: {xs: '0.75rem', sm: '0.8rem'},
                    whiteSpace: 'nowrap',
                  }}
                >
                  {stat.label}
                </Typography>
              </Box>
            </Grid>
          ))}
      </Grid>
    </EntioCard>
  );
}
